
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { TreeNode, NodeType, mapLocationToTreeNode } from '@/modules/nomenclature/models/treeNode';
import * as LocationService from '@/modules/nomenclature/services/locationService';

@Component({
  components: {}
})
export default class SubjectLocationPicker extends Vue {
  @Prop({ required: false })
  protected value?: TreeNode;
  @Prop({ required: false, default: false })
  protected displayErrorMsg?: boolean;
  @Prop({ required: false, default: false })
  protected locked?: boolean;
  protected loading = false;
  protected sites: TreeNode[] = [];
  protected active: string[] = [];

  protected created(): void {
    this.loading = true;
    LocationService.fetchAll()
      .then((response) => {
        for (const location of response.data) {
          const locationNode = mapLocationToTreeNode(location);
          if (locationNode.isLeaf) {
            locationNode.children = undefined;
          }
          this.sites.push(locationNode);
        }
      })
      .finally(() => (this.loading = false));
  }

  protected async fetchLocationChildren(item: TreeNode): Promise<void> {
    return LocationService.fetchChildren(item).then((response) => {
      if (!item.isLeaf) {
        item.children = [];
        for (const child of response.data) {
          const locationNode = mapLocationToTreeNode(child);
          if (locationNode.isLeaf) {
            locationNode.children = undefined;
          }
          item.children.push(locationNode);
        }
      }
    });
  }

  protected clearSelection(): void {
    this.active = [];
    this.$emit('clearSelection');
  }

  @Watch('active')
  protected onSelect(selectArray: string[]): void {
    if (selectArray.length > 0) {
      this.$emit('change', selectArray[0]);
    }
  }

  protected get NodeType(): Record<string, string> {
    return NodeType;
  }
}
